import Modal from "bootstrap/js/dist/modal";

//home services - click on the .card-body triggers the click on the link
document.querySelectorAll("#home-services .card-body").forEach((item) => {
    item.addEventListener("click", () => {
        const link = item.querySelector("a");
        if (link) {
            link.click();
        }
    });
});

//gallery modal
document.querySelectorAll(".gallery-item").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();
        const fullImg = item.getAttribute("href");
        document.getElementById("modalImage").src = fullImg;
        const modal = new Modal(document.getElementById("galleryModal"));
        modal.show();
    });
});

//close the modal on click
function closeModal() {
    const galleryModalElement = document.getElementById("galleryModal");
    if (!galleryModalElement) {
        return;
    }
    galleryModalElement.addEventListener("click", () => {
        const myModal = Modal.getInstance(galleryModalElement);
        myModal.hide();
    });
}
closeModal();

//gallery page load more
document.querySelectorAll("#gallery-load-more").forEach((item) => {
    item.addEventListener("click", (e) => {
        e.preventDefault();

        //get the hidden gallery items
        const hiddenItems = document.querySelectorAll(".gallery-item.d-none");
        if (!hiddenItems) {
            return;
        }
        //loop through the hidden items and show them
        hiddenItems.forEach((hiddenItem, index) => {
            //get the image from the item
            const img = hiddenItem.querySelector("img");
            if (!img) {
                return;
            }
            //get the data-src attribute
            const dataSrc = img.getAttribute("data-src");
            if (!dataSrc) {
                return;
            }
            //set the src attribute
            img.src = dataSrc;
            //remove the hidden class
            hiddenItem.classList.remove("d-none");
        });
        item.remove();
    });
});

//FAQ accordion: add the active class to the parent .accordion element when activated
document
    .querySelectorAll(".accordion .accordion-collapse")
    .forEach((collapse) => {
        collapse.addEventListener("show.bs.collapse", function () {
            this.closest(".accordion-item").classList.add("active");
        });
        collapse.addEventListener("hide.bs.collapse", function () {
            this.closest(".accordion-item").classList.remove("active");
        });
    });

//Service areas accordion: add the active class to the parent .accordion element when activated
document.querySelectorAll(".service-area-inner button").forEach((button) => {
    button.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

//modify the functionality of the main menu with dropdowns on desktop
document.querySelectorAll(".navbar-nav a.dropdown-toggle").forEach((item) => {
    item.addEventListener("click", (e) => {
        //prevent propagation
        e.stopPropagation();

        //get the href attribute
        const href = item.getAttribute("href");
        if (href === "#") {
            return;
        }

        //find the element with the class .offcanvas-start in the element's parent tree
        const offcanvasStart = item.closest(".offcanvas-start");
        if (!offcanvasStart) {
            return;
        }

        //check if the offcanvas has the show class
        const isOffcanvasShown = offcanvasStart.classList.contains("show");
        if (isOffcanvasShown) {
            return;
        }

        //go to the href
        window.location.href = href;
    });
});

//trust bar - simple horizontal slider over the flat <ul class="hero-slider"> at the top of #home-offers
function jsa_hero_slider() {
    const slider = document.querySelector("#home-offers .hero-slider");
    if (!slider) {
        return;
    }

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const delay = 3500;
    let index = 0;
    let timer = null;

    //scroll offset that puts the given item at the start of the visible area
    function itemOffset(item) {
        const padding = parseFloat(window.getComputedStyle(slider).paddingLeft) || 0;
        const offset = item.getBoundingClientRect().left - slider.getBoundingClientRect().left + slider.scrollLeft - padding;
        const max = slider.scrollWidth - slider.clientWidth;
        return Math.max(0, Math.min(offset, max));
    }

    function advance() {
        const max = slider.scrollWidth - slider.clientWidth;
        //everything fits (desktop) - nothing to advance
        if (max <= 1) {
            index = 0;
            return;
        }
        if (slider.scrollLeft >= max - 1) {
            index = 0;
        } else {
            index = Math.min(index + 1, slider.children.length - 1);
        }
        slider.scrollTo({ left: itemOffset(slider.children[index]), behavior: "smooth" });
    }

    function start() {
        if (timer || reduceMotion.matches) {
            return;
        }
        timer = window.setInterval(advance, delay);
    }

    function stop() {
        window.clearInterval(timer);
        timer = null;
    }

    //pause while the visitor is reading or scrolling the bar themselves
    slider.addEventListener("pointerenter", (e) => {
        if (e.pointerType === "mouse") {
            stop();
        }
    });
    slider.addEventListener("pointerleave", (e) => {
        if (e.pointerType === "mouse") {
            start();
        }
    });
    slider.addEventListener("touchstart", stop, { passive: true });
    slider.addEventListener("touchend", start, { passive: true });
    slider.addEventListener("focusin", stop);
    slider.addEventListener("focusout", start);
    document.addEventListener("visibilitychange", () => {
        if (document.hidden) {
            stop();
        } else {
            start();
        }
    });
    reduceMotion.addEventListener("change", (e) => {
        if (e.matches) {
            stop();
        } else {
            start();
        }
    });

    start();
}
jsa_hero_slider();

//home hero - clamp the hero copy to its first two lines on phones so the CTA row stays on the
//first screen, with a caret control that expands it. Desktop is untouched.
function jsa_hero_content_toggle() {
    const copy = document.querySelector("#home-hero .hero-content");
    const toggle = document.querySelector("#home-hero .hero-content-toggle");
    if (!copy || !toggle) {
        return;
    }
    const label = toggle.querySelector(".hero-content-toggle-label");

    //matches @include media-breakpoint-down(sm) in src/sass/theme/_home.scss
    const mq = window.matchMedia("(max-width: 575.98px)");
    let expanded = false;

    //does the copy actually run past the clamp at this width? measured with the clamp
    //applied, since the clamp is what defines "two lines"
    function overflows() {
        const wasCollapsed = copy.classList.contains("is-collapsed");
        copy.classList.add("is-collapsed");
        const over = copy.scrollHeight - copy.clientHeight > 1;
        copy.classList.toggle("is-collapsed", wasCollapsed);
        return over;
    }

    function apply() {
        //above sm, and when the copy already fits, there is nothing to collapse and the
        //control must not take up any space
        if (!mq.matches || !overflows()) {
            copy.classList.remove("is-collapsed");
            toggle.hidden = true;
            return;
        }

        toggle.hidden = false;
        copy.classList.toggle("is-collapsed", !expanded);
        toggle.setAttribute("aria-expanded", String(expanded));
        if (label) {
            label.textContent = expanded ? "Show less" : "Read more";
        }
    }

    function setExpanded(next) {
        expanded = next;
        apply();
    }

    toggle.addEventListener("click", () => setExpanded(!expanded));

    //pointer convenience only - tapping the clamped copy expands it. Deliberately not
    //exposed as a role="button"/tabindex control: its accessible name would be the whole
    //paragraph. The toggle is the keyboard/AT control.
    copy.addEventListener("click", () => {
        if (mq.matches && !expanded) {
            setExpanded(true);
        }
    });

    mq.addEventListener("change", apply);
    window.addEventListener("resize", apply);
    window.addEventListener("load", apply);

    apply();
}
jsa_hero_content_toggle();

//service pages - the "read more" fold. inc/read-more.php splits post_content at the
//[read_more] marker and emits .entry-fold__lede + a hidden toggle + .entry-fold__rest.
//The tail ships visible: JS is what collapses it, so with scripting off the whole page
//renders and the toggle stays hidden. Same direction as jsa_hero_content_toggle() above.
function jsa_content_fold() {
    document.querySelectorAll(".entry-fold").forEach((fold) => {
        const rest = fold.querySelector(".entry-fold__rest");
        const toggle = fold.querySelector(".entry-fold__toggle");
        if (!rest || !toggle) {
            return;
        }
        const label = toggle.querySelector(".entry-fold__toggle-label");
        let expanded = false;

        function apply() {
            rest.classList.toggle("is-collapsed", !expanded);
            toggle.setAttribute("aria-expanded", String(expanded));
            if (label) {
                label.textContent = expanded ? "Show less" : "Read more";
            }
        }

        //the control only exists once we can drive it
        toggle.hidden = false;

        toggle.addEventListener("click", () => {
            expanded = !expanded;
            apply();
        });

        apply();
    });
}
jsa_content_fold();
